import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const PLAN_META: Record<string, string> = {
  trial: 'Piano Trial', base: 'Piano Base', medium: 'Piano Medium', premium: 'Piano Premium',
};

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const planId = searchParams.get('plan') || '';
  const price = searchParams.get('price') || '0';
  const last4 = searchParams.get('last4') || '****';
  const brand = searchParams.get('brand') || 'card';
  const iva = (parseFloat(price) * 0.22).toFixed(2);
  const total = (parseFloat(price) * 1.22).toFixed(2);
  const today = new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' });
  const renewDate = new Date();
  renewDate.setMonth(renewDate.getMonth() + 1);
  const renewStr = renewDate.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });

  return (
    <div className="page" style={{ justifyContent: 'center', minHeight: 'calc(100vh - 100px)', textAlign: 'center' }}>

      {/* Icona successo */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <div style={{ width: 88, height: 88, borderRadius: '50%', background: 'var(--success-sub)', border: '3px solid var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span className="mi" style={{ fontSize: 44, color: 'var(--success)' }}>check</span>
        </div>
        <div>
          <h1 style={{ marginBottom: 8 }}>Abbonamento attivato! 🎉</h1>
          <p className="sub">Il tuo {PLAN_META[planId] || 'piano'} è ora attivo.</p>
        </div>
      </div>

      {/* Riepilogo */}
      <div style={{ background: 'var(--s1)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 16, textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Piano</span>
          <span style={{ fontSize: 13, fontWeight: 600 }}>{PLAN_META[planId] || planId}</span>
        </div>
        <div style={{ height: 1, background: 'var(--border)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Imponibile</span>
          <span style={{ fontSize: 13, fontWeight: 600 }}>€{parseFloat(price).toFixed(2)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>IVA 22%</span>
          <span style={{ fontSize: 13, fontWeight: 600 }}>€{iva}</span>
        </div>
        <div style={{ height: 1, background: 'var(--border)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Totale pagato</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--primary)' }}>€{total}</span>
        </div>
        <div style={{ height: 1, background: 'var(--border)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Attivato il</span>
          <span style={{ fontSize: 13, fontWeight: 600 }}>{today}</span>
        </div>
        {planId !== 'trial' && (
          <>
            <div style={{ height: 1, background: 'var(--border)' }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Prossimo rinnovo</span>
              <span style={{ fontSize: 13, fontWeight: 600 }}>€{total} · {renewStr}</span>
            </div>
          </>
        )}
        <div style={{ height: 1, background: 'var(--border)' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: 'var(--text-2)' }}>Carta</span>
          <span style={{ fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
            <span className="mi mi-16" style={{ color: 'var(--text-3)' }}>credit_card</span>
            {brand} •••• {last4}
          </span>
        </div>
      </div>

      <button className="btn btn-primary" style={{ fontSize: 15, padding: 17 }} onClick={() => navigate('/')}>
        <span className="mi mi-20">rocket_launch</span> Vai alla dashboard
      </button>
    </div>
  );
}
